<template>
  <div class="def-insert-tilda"></div>
</template>

<script>
export default {
  name: 'DefInsertTilda',
  props: ['result'],
  mounted() {
    this.appendHtml(this.createHtmlFromString(this.result));
  },
  methods: {
    /**
     * create DOM elements from string
     * @param data
     * @returns {*}
     */
    createHtmlFromString(data) {
      data = data.replace(/\$\(document\)\.ready\(/g, '$(window).on("load",');
      data = data.replace(/\$\(window\)\.load\(/g, '$(window).on("load",');

      return document.createRange().createContextualFragment(data);
    },
    /**
     * insert html in page
     * @param html
     */
    appendHtml(html) {
      this.$el.appendChild(html);
    },
  },
};
</script>

<style lang="scss" scoped>
.def-insert-tilda {
  :deep(*),
  :deep(*:after),
  :deep(*:before) {
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
  }
  :deep(img) {
    display: inline-block;
  }
  :deep {
    .t-col {
      @media screen and (max-width: 960px) {
        box-sizing: border-box;
      }
    }
  }
}
</style>
